import { configure, makeAutoObservable } from 'mobx';

import ManageUserDataService from '../../services/UserAccount/ManageUserDataService';
import { NotificationsStore } from '../NotificationsStore';
import { getErrorMessage } from 'utilities/ErrorHelper';

configure({ enforceActions: 'never' });

export class ManageUserDataStore {
  private manageUserDataService: ManageUserDataService;
  private ns: NotificationsStore;

  constructor(manageUserDataService: ManageUserDataService, notificationStore: NotificationsStore) {
    makeAutoObservable(this); //This line will automatically decorate each store property with 'observable' and each method with 'action'.
    this.manageUserDataService = manageUserDataService;
    this.ns = notificationStore;
  }

  supportMembershipUserId: string = '';
  terminateSubscriptionUserId: string = '';
  giveLevel1CertUserId: string = '';
  resetLevel1CertUserId: string = '';
  giveLevel2CertUserId: string = '';
  resetLevel2CertUserId: string = '';
  giveLevelMasterUserId: string = '';
  userSearchEmail: string = '';
  foundUserId: string = '';
  userSearchId: string = '';
  foundUserEmail: string = '';
  isLoading: boolean = false;
  generateCertificatePdfUserId: string = '';

  addSupportMembership = async () => {
    try {
      this.isLoading = true;
      await this.manageUserDataService.addSupportMembership(this.supportMembershipUserId);
      this.ns.addToast('success', 'Support membership has been added', 'success');
    } catch (ex) {
      this.ns.addToast('error', getErrorMessage(ex), 'error');
    }
    this.supportMembershipUserId = '';
    this.isLoading = false;
  };

  cancelSupportMembership = async () => {
    try {
      this.isLoading = true;
      await this.manageUserDataService.cancelSupportMembership(this.supportMembershipUserId);
      this.ns.addToast('success', 'Support membership has been cancelled', 'success');
    } catch (ex) {
      this.ns.addToast('error', getErrorMessage(ex), 'error');
    }
    this.supportMembershipUserId = '';
    this.isLoading = false;
  };

  terminateSubscription = async () => {
    try {
      this.isLoading = true;
      await this.manageUserDataService.terminateSubscription(this.terminateSubscriptionUserId);
      this.ns.addToast('success', 'Player subscription has been terminated', 'success');
    } catch (ex) {
      this.ns.addToast('error', getErrorMessage(ex), 'error');
    }
    this.terminateSubscriptionUserId = '';
    this.isLoading = false;
  };

  updatePlayerLevelMaster = async () => {
    try {
      this.isLoading = true;
      await this.manageUserDataService.updatePlayerLevelMaster(this.giveLevelMasterUserId);
      this.ns.addToast('success', 'Player level Master has been updated', 'success');
    } catch (ex) {
      this.ns.addToast('error', getErrorMessage(ex), 'error');
    }
    this.giveLevelMasterUserId = '';
    this.isLoading = false;
  };

  getUserIdByEmail = async () => {
    try {
      this.isLoading = true;
      const response = await this.manageUserDataService.getUserIdByEmail(this.userSearchEmail);
      this.foundUserId = response;
    } catch (ex) {
      this.ns.addToast('error', getErrorMessage(ex), 'error');
    }
    this.userSearchEmail = '';
    this.isLoading = false;
  };

  getUserEmailById = async () => {
    try {
      this.isLoading = true;
      const response = await this.manageUserDataService.getUserEmailById(this.userSearchId);
      this.foundUserEmail = response;
    } catch (ex) {
      this.ns.addToast('error', getErrorMessage(ex), 'error');
    }
    this.userSearchId = '';
    this.isLoading = false;
  };

  generateCertificatePdf = async () => {
    try {
      this.isLoading = true;
      const response = await this.manageUserDataService.generateCertificatePdf(this.generateCertificatePdfUserId).then((response) => {
        if (response.status === 'error') {
          this.ns.addToast('error', response.data, 'error');
          return;
        }
        const href = window.URL.createObjectURL(response.data);
        const anchorElement = document.createElement('a');
        anchorElement.href = href;
        anchorElement.download = `TrackMan-Certificate-master.pdf`;
        anchorElement.style.display = 'none';

        document.body.appendChild(anchorElement);
        anchorElement.click();
        
        document.body.removeChild(anchorElement);
        window.URL.revokeObjectURL(href);
      });
    } catch (ex) {
      this.ns.addToast('error', getErrorMessage(ex), 'error');
    }
    this.generateCertificatePdfUserId = '';
    this.isLoading = false;
  };
}

export default ManageUserDataStore;
